var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComments = function SvgComments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "comments_noun_message_965435 copy 24")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elenco-Piatti/Ricette/Ristoranti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utente_loggato_men\\xF9",
    transform: "translate(-1193.000000, -991.000000)",
    fill: "#009672",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(979.000000, 660.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_message_965435-copy-24",
    transform: "translate(214.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05555556,19.83 L8.66666667,19.83 L15,23.91 L14.6944444,19.86 L15.1111111,19.86 C16.7222222,19.86 18.0555556,18.51 18.1666667,16.8 L21.8333333,19.14 L21.5277778,15.09 L21.9444444,15.09 C23.6388889,15.09 25,13.62 25,11.79 L25,3.3 C25,1.47 23.6388889,0 21.9444444,0 L9.88888889,0 C8.19444444,0 6.83333333,1.47 6.83333333,3.3 L6.83333333,4.74 L3.05555556,4.74 C1.36111111,4.74 0,6.24 0,8.04 L0,16.53 C0,18.36 1.36111111,19.83 3.05555556,19.83 Z M7.97222222,3.3 C7.97222222,2.16 8.83333333,1.23 9.88888889,1.23 L21.9444444,1.23 C23,1.23 23.8611111,2.16 23.8611111,3.3 L23.8611111,11.79 C23.8611111,12.93 23,13.86 21.9444444,13.86 L20.3055556,13.86 L20.5277778,16.89 L18.1666667,15.39 L18.1666667,8.04 C18.1666667,6.21 16.8055556,4.74 15.1111111,4.74 L7.97222222,4.74 L7.97222222,3.3 Z M1.13888889,8.04 C1.13888889,6.9 2,5.97 3.05555556,5.97 L15.1111111,5.97 C16.1666667,5.97 17.0277778,6.9 17.0277778,8.04 L17.0277778,16.53 C17.0277778,17.67 16.1666667,18.6 15.1111111,18.6 L13.4722222,18.6 L13.6944444,21.63 L8.97222222,18.6 L3.05555556,18.6 C2,18.6 1.13888889,17.67 1.13888889,16.53 L1.13888889,8.04 Z",
    id: "Shape"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comments.13ff83e0.svg";
export { ForwardRef as ReactComponent };